import {
  CREATE_QRCODE,
  GET_QRCODES,
  GET_QRCODE,
  UPDATE_QRCODE,
  DELETE_QRCODE,
  GET_QRCODE_STATISTICS,
  GENERATE_CONTENT_PREVIEW,
  SET_QRCODE_ERROR,
} from "../actions/qrCodeActions";

const initialState = {
  qrCodes: [],
  qrCode: null,
  statistics: null,
  contentPreview: null,
  error: null,
  currentPage: 1,
  numberOfPages: 1,
};

const qrCodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_QRCODE:
      return {
        ...state,
        qrCodes: [action.payload.data, ...state.qrCodes],
        error: null,
      };

    case GET_QRCODES:
      return {
        ...state,
        qrCodes: action.payload.data,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
        error: null,
      };

    case GET_QRCODE:
      return {
        ...state,
        qrCode: action.payload.data,
        error: null,
      };

    case UPDATE_QRCODE:
      return {
        ...state,
        qrCodes: state.qrCodes.map((qrCode) =>
          qrCode._id === action.payload.data._id ? action.payload.data : qrCode
        ),
        qrCode: action.payload.data,
        error: null,
      };

    case DELETE_QRCODE:
      return {
        ...state,
        qrCodes: state.qrCodes.filter((qrCode) => qrCode._id !== action.payload),
        error: null,
      };

    case GET_QRCODE_STATISTICS:
      return {
        ...state,
        statistics: action.payload.data,
        error: null,
      };

    case GENERATE_CONTENT_PREVIEW:
      return {
        ...state,
        contentPreview: action.payload.data,
        error: null,
      };

    case SET_QRCODE_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default qrCodeReducer;
